var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarDone28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_done_28-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.848 3.11c.691-1.4 1.037-2.1 1.506-2.325a1.5 1.5 0 0 1 1.292 0c.469.224.815.925 1.506 2.326l1.845 3.738c.204.414.306.62.456.781.09.097.191.181.303.25l-.761.761a4.5 4.5 0 0 0-6.177 6.541l3 3a4.5 4.5 0 0 0 6.364 0l.386-.386.016.093.705 4.108c.264 1.54.396 2.31.148 2.767a1.5 1.5 0 0 1-1.045.759c-.511.095-1.203-.269-2.586-.996l-3.69-1.94c-.408-.215-.612-.322-.827-.364a1.499 1.499 0 0 0-.578 0c-.215.042-.42.15-.828.364l-3.69 1.94c-1.382.727-2.074 1.09-2.585.996a1.5 1.5 0 0 1-1.045-.76c-.248-.456-.116-1.226.148-2.766l.705-4.108c.078-.456.117-.683.09-.9a1.5 1.5 0 0 0-.178-.55c-.106-.191-.272-.352-.602-.675l-2.985-2.91c-1.119-1.09-1.678-1.635-1.746-2.15a1.5 1.5 0 0 1 .399-1.229c.358-.377 1.13-.49 2.677-.714l4.125-.6c.457-.066.685-.099.884-.191a1.5 1.5 0 0 0 .467-.34c.15-.16.252-.367.456-.781l1.845-3.738ZM27.06 8.06a1.5 1.5 0 0 0-2.122-2.12L18 12.878l-1.94-1.94a1.5 1.5 0 0 0-2.12 2.122l3 3a1.5 1.5 0 0 0 2.12 0l8-8Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_done_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDone28);
export default __webpack_public_path__ + "static/media/star_done_28.d5082ca5.svg";
export { ForwardRef as ReactComponent };